import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import App from './App';
import { ApolloProvider } from '@apollo/client';
import GlobalProvider from 'contexts';
import { client } from 'services/apolloInit';
import 'antd/dist/antd.variable.min.css';
// AskAsper / asper_design_library styles. The craco config rewrites the bundled
// `.ant-`/`.anticon` selectors in this file to the `ant5-`/`ant5icon` prefix so the
// design library's antd 5 styles never collide with the main app's antd 4 styles.
import 'asper_design_library/dist/style.css';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from 'services/reactQueryService';
import ErrorBoundary from 'components/pages/ErrorBoundary';
import { ConfigProvider } from 'antd';
import { capturePostLoginRedirect } from 'utils/postLoginRedirect';

// Capture the pristine deep link before BrowserRouter / effects can navigate,
// so a shared filtered URL survives the auth bootstrap redirect through `/`.
capturePostLoginRedirect();

ConfigProvider.config({
    theme: {
        primaryColor: '#3B2C77',
    },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    // <React.StrictMode>
    <ApolloProvider client={client}>
        <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools buttonPosition="bottom-left" />
            <BrowserRouter>
                <ConfigProvider>
                    {/* <GlobalProvider> */}
                    <ErrorBoundary>
                        <App />
                    </ErrorBoundary>
                </ConfigProvider>
                {/* </GlobalProvider> */}
            </BrowserRouter>
        </QueryClientProvider>
    </ApolloProvider>,

    // </React.StrictMode>,
);
